import React, {Component} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import {PayContainer} from "./PayContainer";

class App extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={PayContainer}/>
                </Switch>
            </Router>)
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js